(function ($) {
	class W4D_CarouselTabs {
		constructor() {
			this.initSelectors();
			this.bindEvents();
		}

		initSelectors() {
			this.$tabLinks = $('.js-tab-link');
		}

		bindEvents() {
			this.$tabLinks.on('click', (e) => this.tabTrigger(e));
		}

		tabTrigger(e) {
			const $el = $(e.target);
			const $tabsWrapper = $el.closest('.js-tabs');
			const $elLi = $el.closest('li');
			const $tabContentsWrapper = $tabsWrapper.find('.js-tabs-content-wrapper');

			// Get index of clicked tab
			const index = $elLi.index();
			this.toggleActiveNav($el, $tabsWrapper);

			// Hide all tab contents and show the selected one
			$tabContentsWrapper.children().hide();
			$tabContentsWrapper.children().eq(index).show();
		}

		// Only within its own tabs: a page can have several (landing blocks, product collections in a post)
		toggleActiveNav($el, $tabsWrapper) {
			$tabsWrapper.find('.js-tab-link').removeClass('active');
			$el.addClass('active');
		}
	}

	$(document).ready(() => new W4D_CarouselTabs());
})(jQuery);
